import { render, staticRenderFns } from "./livebo.vue?vue&type=template&id=7216c986&scoped=true"
import script from "./livebo.vue?vue&type=script&lang=js"
export * from "./livebo.vue?vue&type=script&lang=js"
import style0 from "./livebo.vue?vue&type=style&index=0&id=7216c986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216c986",
  null
  
)

export default component.exports